import { render, staticRenderFns } from "./FilterBankMovements.vue?vue&type=template&id=b615254e"
import script from "./FilterBankMovements.vue?vue&type=script&lang=js"
export * from "./FilterBankMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports